function UpdateMasterSelect(card, selected_options) {
    let variants_list = card.querySelectorAll('.variants-values li');
    let options_items = card.querySelectorAll('.variant-option-selection');
    let variant_id = '';
    variants_list.forEach((item) => {
        if (item.getAttribute('data-name').trim().includes(selected_options.trim())) {
            // change select element option based on item data-id attribute
            variant_id = item.getAttribute('data-id');
        }
    });
    return variant_id;
}

function updateSelectBox() {
    const productCards = document.querySelectorAll('.collection-product-options'); // Replace with your card's class name
    productCards.forEach((card) => {
        const selectElements = card.querySelectorAll('.variant-option-selection');
        const button = card.querySelector('.collection-select-options');
        const cartButton = card.querySelector('.collection-add-to-cart');
        let varaintJSON = [];
        if (card.querySelector('[data-variant-json]')) {
            varaintJSON = JSON.parse(card.querySelector('[data-variant-json]').innerHTML);
        }
        // Function to check if all selects within the current card have values
        function checkAllSelected() {
            var selected_options = '';
            let allSelected = true;
            selectElements.forEach((select) => {
                if (select.value == '') {
                    allSelected = false;
                } else {
                    let errorElement = select.previousElementSibling;
                    if (errorElement) {
                        errorElement.style.display = 'none'
                    }
                    selected_options += select.value + ' '
                }
            });
            return { "select": allSelected, "result": selected_options };
        }
        // Event listener for change on each select element
        selectElements.forEach((select) => {
            select.addEventListener('change', function () {
                const parentContent = event.target.closest('.product__card');
                let productId = this.dataset.productid;
                let currentlySelectedOptions = checkAllSelected();
                if (currentlySelectedOptions['select']) {
                    let variant_id = UpdateMasterSelect(card, currentlySelectedOptions['result']);
                    if (variant_id != '') {
                        if (variant_id !== '' && productId != '') {
                            let variantJson = JSON.parse(document.querySelector(".product-" + productId).textContent);
                            let selectedVariantJSON = variantJson.find((variant) => {
                                return variant.id == variant_id
                            });
                            if (selectedVariantJSON) {
                                let from_price = parentContent.querySelector(".from_price");
                                let savingBadge = parentContent.querySelector(".savings-badge")
                                if (from_price) {
                                    from_price.style.display = 'none';
                                }
                                let originalPrice = parentContent.querySelector('.sp-product-card__price-sale.original-price');
                                let currentPrice = parentContent.querySelector('.sp-product-card__price-original.current-price');
                                if (originalPrice) {
                                    if (selectedVariantJSON.compare_at_price != null) {
                                        originalPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.compare_at_price, theme.settings.moneyFormat)
                                        originalPrice.classList.remove('hidden')
                                        if (savingBadge) {
                                            savingBadge.classList.remove('hidden')
                                        }
                                    } else {
                                        originalPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat);
                                        originalPrice.classList.add('hidden')
                                        if (savingBadge) {
                                            savingBadge.classList.add('hidden')
                                        }
                                    }
                                }
                                if (currentPrice) {
                                    if (selectedVariantJSON.compare_at_price != null) {
                                        currentPrice.classList.add('has-discount', 'discounted')
                                    } else {
                                        currentPrice.classList.remove('has-discount', 'discounted')
                                    }
                                    currentPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                                }
                                if (!selectedVariantJSON.available) {
                                    cartButton.classList.add('sold-out-btn')
                                    cartButton.setAttribute('disabled', 'disabled')
                                    cartButton.querySelector('.btn__text').innerHTML = cartButton.dataset.soldout;
                                } else {
                                    cartButton.classList.remove('sold-out-btn')
                                    cartButton.removeAttribute("disabled");
                                    cartButton.querySelector('.btn__text').innerHTML = cartButton.dataset.addtocart;
                                }
                            }
                            cartButton.setAttribute(
                                'onclick',
                                `event.preventDefault();document.querySelector('ajax-cart').addToCart('${variant_id}')`
                            );
                        }
                        button.style.display = 'none'; // Show button if all options have values
                        cartButton.style.display = 'flex';
                        button.removeAttribute('disabled')
                    } else {
                        button.querySelector('span').innerHTML = 'Unavailable'
                        button.style.display = ''; // Show button if all options have values
                        button.setAttribute('disabled', 'disabled')
                        cartButton.style.display = 'none';
                    }
                } else {
                    button.removeAttribute('disabled')
                    button.querySelector('span').innerHTML = 'Select Options'
                    button.style.display = ''; // Hide button if any option is missing a value
                    cartButton.style.display = 'none';
                }
            });
        });
    });
}